<script>
import AdminLayout from '@layouts/admin-main'
import TransferList from '@components/admin/withdraw-transfer-list'

export default {
  page: {
    title: 'Admin::WithdrawTransferList',
    meta: [{ name: 'description', content: 'Admin::WithdrawTransferList' }],
  },
  components: { AdminLayout, TransferList },
}
</script>

<template>
  <AdminLayout>
    <TransferList></TransferList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
